var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.578,
    height: 41.578,
    viewBox: "0 0 41.578 41.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Inner_circle",
    "data-name": "Inner circle",
    d: "M16.412,0A16.412,16.412,0,1,1,0,16.412,16.412,16.412,0,0,1,16.412,0Z",
    transform: "translate(4.377 4.377)",
    fill: "#ff8900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outern_circle",
    "data-name": "Outern circle",
    d: "M16.789.377A16.412,16.412,0,1,0,33.2,16.789,16.412,16.412,0,0,0,16.789.377m0-4.377a20.784,20.784,0,0,1,14.7,35.489A20.789,20.789,0,1,1,8.7-2.364,20.663,20.663,0,0,1,16.789-4Z",
    transform: "translate(4 4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M-.349-9.529l-2.364-3.939A1.092,1.092,0,0,0-3.651-14h-3.8a.547.547,0,0,0-.448.861L-4.1-7.7A7.076,7.076,0,0,1-.349-9.529ZM8.958-14h-3.8a1.094,1.094,0,0,0-.938.531L1.856-9.529A7.078,7.078,0,0,1,5.6-7.7l3.8-5.435A.547.547,0,0,0,8.958-14ZM.753-8.529A6.018,6.018,0,0,0-5.265-2.511,6.018,6.018,0,0,0,.753,3.507,6.018,6.018,0,0,0,6.771-2.511,6.018,6.018,0,0,0,.753-8.529ZM3.917-3.152,2.62-1.888,2.927-.1a.393.393,0,0,1-.569.413L.753-.532-.85.311A.392.392,0,0,1-1.42-.1l.307-1.786-1.3-1.264a.393.393,0,0,1,.217-.67L-.4-4.083.4-5.708a.386.386,0,0,1,.352-.218.39.39,0,0,1,.353.218l.8,1.625L3.7-3.822A.393.393,0,0,1,3.917-3.152Z",
    transform: "translate(20.036 27.13)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.32e3dd6af1447def213dbd2c20d359c1.svg";
export { ForwardRef as ReactComponent };